import { FiLoader, FiTrash2 } from "react-icons/fi"

export const PopUpDeleteConfirmation = ({ open, setOpen, title, message, onConfirm, loading }) => {
    return (
        <>
            <div className={`fixed inset-0 z-[110] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm transition-all duration-500 ${open ? 'scale-100 rounded-0' : 'scale-0 rounded-full'}`}>
                <div className="bg-white rounded-2xl p-6 w-full max-w-xs shadow-2xl text-center transform transition-all">
                    <div className="w-16 h-16 bg-red-100 text-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                        <FiTrash2 size={30} />
                    </div>

                    <h3 className="text-lg font-bold text-gray-800 mb-2">{title}</h3>
                    <p className="text-sm text-gray-500 mb-6">{message}</p>

                    <div className="flex gap-3">
                        <button
                            onClick={() => setOpen(false)}
                            className="flex-1 px-4 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-600 rounded-xl font-bold text-sm transition-all"
                        >
                            Batal
                        </button>
                        <button
                            onClick={onConfirm}
                            disabled={loading}
                            className="flex-1 px-4 py-2.5 bg-red-600 hover:bg-red-700 text-white rounded-xl font-bold text-sm transition-all shadow-md flex items-center justify-center gap-2"
                        >
                            {loading ? <FiLoader className="animate-spin" /> : "Ya, Hapus"}
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}